export default "__VITE_ASSET__Dw34OHyo__"